import type { PdfColorMode } from "./pdfTheme";

const PUBLIC_BASE = `${process.env.PUBLIC_URL ?? ""}/metrics-pdf`;

const PLATFORM_LOGO_BASE = "https://podscope.s3.amazonaws.com/platforms";

/** Dark wordmark on light pages; light wordmark on dark pages. */
export function getPdfWordmarkSrc(mode: PdfColorMode = "light"): string {
  return mode === "dark"
    ? `${PUBLIC_BASE}/podscope-wordmark-light.png`
    : `${PUBLIC_BASE}/podscope-wordmark-dark.png`;
}

export function getPdfPlatformLogoSrc(
  platform: "youtube" | "instagram" | "tiktok" | "facebook",
): string {
  return `${PLATFORM_LOGO_BASE}/${platform}.png`;
}

export function getPdfFontRegularSrc(): string {
  return `${PUBLIC_BASE}/fonts/DMSans-Regular.ttf`;
}

export function getPdfFontBoldSrc(): string {
  return `${PUBLIC_BASE}/fonts/DMSans-Bold.ttf`;
}

export function getPdfPodscopeSquareSrc(): string {
  return `${PUBLIC_BASE}/podscope-square.png`;
}
